// render - profile page
import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from 'components/ProtectedRoute';
import Province from '../pages/province/Province';
import ProvinceRules from '../pages/Rules/ProvinceRules';
import UserListing from '../components/user/UserListing';
import Properties from '../pages/properties/Properties';
import ProfilePage from '../pages/profile/ProfilePage';
import Leases from '../pages/leases/Leases';
import Payments from '../pages/payments/Payments';
import Notices from '../pages/Notices/Notices';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));



const MainRoutes = {
  path: '/',
  element: <ProtectedRoute />, // Only the guard here
  children: [
    {
      path: '/',
      element: <DashboardLayout />, // Layout here
      children: [
        {
          path: 'dashboard',
          element: <UserListing />
        },
        {
          path: 'dashboard/province',
          element: <Province />
        },
        {
          path: 'dashboard/province-rules',
          element: <ProvinceRules />
        },
        {
          path: 'dashboard/properties',
          element: <Properties />
        },
        {
          path: 'dashboard/profile',
          element: <ProfilePage />
        },
        {
          path: 'dashboard/leases',
          element: <Leases />
        },
        {
          path: 'dashboard/payments',
          element: <Payments />
        },
        {
          path: 'dashboard/notices',
          element: <Notices />
        }
      ]
    }
  ]
};

export default MainRoutes;
